
import { processSkin, processLogo, processSharing, processDownload } from './Configuration';

const seek = ({ time, forcePositive, forcePause } = {}, player) => {
  const duration = player.getDuration();
  const toAdd = forcePositive && duration < 0 ? duration : 0;
  const timeToSeek = parseInt( time, 10) + toAdd;
  if( forcePause) player.once( 'seeked', _ => player.pause() );
  player.seek( timeToSeek);
};

const getCurrentSecond = ({ forcePositive }, player) => {
  const second = player.getPosition();
  return forcePositive && second < 0 ? Math.abs( player.getDuration()) + second : second;
};

const getPlaylistInfo = ({ playlist, auxiliarData } = {}, player) => {
  const { programmationInfo } = auxiliarData ?? {};
  const { effectiveTimeStampStart, mode, finalDate } = programmationInfo ?? {};
  return {
    currentElement: player.getPlaylistItem().index ?? 0,
    effectiveTimeStampStart,
    mode,
    finalDate,
    playlist,
  };
};

const updateSettings = ({ design, socialSharing, download } = {}, { customProps, auxiliarData } = {}) => {
  if( !customProps) customProps = {};
  if( !auxiliarData) auxiliarData = {};
  if( design) {
    customProps.skin = processSkin( design);
    customProps.logo = processLogo( design);
  }
  if( socialSharing) {
    customProps.sharing = processSharing( socialSharing);
  }
  if( download) {
    auxiliarData.download = processDownload( download);
  }
};

const PostMessages = {

  handleMessage: (message, configuration, player) => {
    // console.log( 'controllers::custom_3_player::PostMessages::handleMessage() - message: ', message, ', configuration: ', configuration, ', player: ', player);   // DEVELOP
    const response = {
      updatedConfiguration: null,
      unprocessedMessage: false,    // NOTE esta marca solo indica si un evento no se ha manejado por que no corresponde a este manejador
      // REVIEW TODO marcar adecuadamente eventos que no se han manejado por imposibilidad temporal (ejemplo: el player aun no se ha cargado)
            // NOTE de momento solo se ignoran
    }

    const { data } = message;
    switch( data.operation) {
      case 'pause': if( player) {
          if( data.value) player.pause();
          else player.play();
        }
        break;
      case 'mute': if( player) {
          player.setMute( data.value);
        }
        break;
      case 'seek': if( player) {
          seek( data, player);
        }
        break;
      case 'getMp4Url': if( player) {
          message.source.postMessage( { mp4Url: player.getPlaylistItem().progressive, token: data.token }, message.origin);
        }
        break;
      case 'getCurrentSecond': if( player) {
          const second = getCurrentSecond( data, player);
          message.source.postMessage({ second, token: data.token }, message.origin);
        }
        break;
      case 'getDuration': if( player) {
          message.source.postMessage({ seconds: player.getDuration(), token: data.token }, message.origin);
        }
        break;
      case 'getPlaylistInfo': if( player) {
          const playlistInfo = getPlaylistInfo( configuration.custom_3_playerConfiguration, player);
          message.source.postMessage({ ...playlistInfo, token: data.token }, message.origin);
        }
        break;
      // case 'getImage': break;   // REVIEW unused deprecated
      case 'changeStreamOrigin': if( player) {
          player.load([{ file: data.streamOrigin }]);
          seek( data, player);
        }
        break;
      case 'updateSettings': if( player) {
          if( data.design || data.socialSharing || data.download) {
            response.updatedConfiguration = { ...configuration, custom_3_playerConfiguration: JSON.parse( JSON.stringify( configuration.custom_3_playerConfiguration)) };
            updateSettings( data, response.updatedConfiguration.custom_3_playerConfiguration);
            response.updatedConfiguration.custom_3_playerConfiguration.key = Math.random();
          }
        }
        break;
      default:
        response.unprocessedMessage = true;
    }

    return response;
  },

};

export default PostMessages;